module.exports = "/ui/fonts/slick.ttf";